module.exports = __webpack_public_path__ + "static/media/job_started.80ff7063.svg";